export const WTS_IGNORED_FIELDS = ['Created', 'Modified', 'CreatorId', 'ModifierId'];
export const ABSENCES_FLAG = {
    NotPlanned: 1,
    Planned: 2,
    Cancelled: 4
};
export const TIME_RATE_SYSTEMS = {
    SummaryTimeRate: 'summed',
    DailyTimeRate: 'daily',
    AgencyAgreement: 'agencyAgreement',
    SummedEqualWeek: 'summedEqualWeek',
    SummedWorkWeek: 'summedWorkWeek',
    FlexibleWorkTime: 'flexibleWorkTime'
};
export var EdeImportResultMsg;
(function (EdeImportResultMsg) {
    EdeImportResultMsg["Ignored"] = "Ignored";
    EdeImportResultMsg["Inserted"] = "Inserted";
    EdeImportResultMsg["Updated"] = "Updated";
})(EdeImportResultMsg || (EdeImportResultMsg = {}));
export var SORT_ORDER;
(function (SORT_ORDER) {
    SORT_ORDER["ASC"] = "asc";
    SORT_ORDER["DESC"] = "desc";
})(SORT_ORDER || (SORT_ORDER = {}));
export var USER_VISIBILITY_RIGHT_LEVEL;
(function (USER_VISIBILITY_RIGHT_LEVEL) {
    USER_VISIBILITY_RIGHT_LEVEL["USER"] = "User";
    USER_VISIBILITY_RIGHT_LEVEL["DEPARTMENT"] = "Department";
    USER_VISIBILITY_RIGHT_LEVEL["COMPANY"] = "Company";
})(USER_VISIBILITY_RIGHT_LEVEL || (USER_VISIBILITY_RIGHT_LEVEL = {}));
export var OVER_UNDER_TIME_OPTIONS;
(function (OVER_UNDER_TIME_OPTIONS) {
    OVER_UNDER_TIME_OPTIONS["WORK_TIME"] = "workTime";
    OVER_UNDER_TIME_OPTIONS["OVER_TIME"] = "overTime";
    OVER_UNDER_TIME_OPTIONS["UNDER_TIME"] = "underTime";
    OVER_UNDER_TIME_OPTIONS["OVER_UNDER_SUMMARY"] = "overUnderSummary";
    OVER_UNDER_TIME_OPTIONS["AGREED_HOURS"] = "agreedHours";
    OVER_UNDER_TIME_OPTIONS["ADDITIONAL_HOURS"] = "additionalHours"; // FlexibleWorkTime only (WorkTimeType 7)
})(OVER_UNDER_TIME_OPTIONS || (OVER_UNDER_TIME_OPTIONS = {}));
